// src/Components/Common/ReadMoreLessHTML.tsx
import React, { useState } from "react";
import DOMPurify from "dompurify";

interface ReadMoreLessHTMLProps {
  html: string;
  maxChars?: number;
  allowedTags?: string[];
}

const ReadMoreLessHTML: React.FC<ReadMoreLessHTMLProps> = ({
  html,
  maxChars = 100,
  allowedTags = ['p', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6'],
}) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const plainText = html.replace(/<[^>]+>/g, "");
  const isLong = plainText.length > maxChars;

  const toggleExpanded = () => setIsExpanded(!isExpanded);

  const displayHTML = isExpanded
    ? html
    : plainText.slice(0, maxChars) + (isLong ? "..." : "");

  return (
    <div>
      <div
        dangerouslySetInnerHTML={{
          __html: DOMPurify.sanitize(displayHTML, { ALLOWED_TAGS: allowedTags }),
        }}
      />
      {isLong && (
        <span
          style={{ color: "#007bff", cursor: "pointer" }}
          onClick={toggleExpanded}
        >
          {isExpanded ? "Read less" : "Read more"}
        </span>
      )}
    </div>
  );
};

export default ReadMoreLessHTML;
